<template>
  <v-dialog
    v-model="show"
    :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
    persistent
  >
    <v-card class="rounded-xl" color="#ffffffD9">
      <v-card-title class="">
        <span
          class="
                  primary--text
                  text-subtitle-2
                  text-sm-subtitle-1
                  text-md-subtitle-1
                  text-lg-subtitle-1
                  text-xl-subtitle-1
                "
          >{{ translations.update_sample_data }}</span
        >
      </v-card-title>
      <v-card-text class="my-0 py-0">
        <v-container v-if="sample">
          <v-form lazy-validation ref="form">
            <v-row>
              <v-col cols="12">
                <v-select
                  outlined
                  dense
                  :label="translations.select_sampling_type"
                  :items="samplingType"
                  v-model="sampleType"
                  return-object
                  background-color="white"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  sample.status != 'NOT_STARTED' &&
                    sample.status != 'IN_PROGRESS'
                "
              >
                <v-select
                  outlined
                  dense
                  :label="translations.label_sample_type"
                  background-color="white"
                  return-object
                  :items="analysisTypes"
                  v-model="analysisType"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                v-if="sampleType && sampleType.value == 'MAS_VEGETABLE'"
              >
                <v-select
                  outlined
                  dense
                  :label="translations.label_plant_sample_type"
                  :items="vegetalSampleTypes"
                  v-model="vegetalType"
                  return-object
                  background-color="white"
                  :rules="[(v) => !!v || translations.field_required]"
                ></v-select>
              </v-col>
              <v-col v-if="currentPackageName">
                <span class="black--text">
                  {{ translations.current_package }}:
                </span>
                <span class="font-weight-bold primary--text">
                  {{ currentPackageName }}
                </span>
              </v-col>
              <v-col cols="12" v-if="packagesSolena.length > 0">
                <v-select
                  outlined
                  clearable
                  dense
                  :label="translations.label_select_package"
                  background-color="white"
                  :items="packagesSolena"
                  :item-text="formatItemText"
                  v-model="packagesSolenaSelected"
                  return-object
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col class="text-end">
              <v-btn
                color="warning"
                @click="closeModal"
                block
                :disabled="loading"
                class="
                  mb-5
                  text-subtitle-2
                  text-sm-subtitle-1
                  text-md-subtitle-1
                  text-lg-subtitle-1
                  text-xl-subtitle-1
                "
              >
                {{ translations.cancel }}
              </v-btn>
            </v-col>
            <v-col class="text-end">
              <v-btn
                color="primary"
                @click="save"
                block
                :loading="loading"
                class="
                  mb-5
                  text-subtitle-2
                  text-sm-subtitle-1
                  text-md-subtitle-1
                  text-lg-subtitle-1
                  text-xl-subtitle-1
                "
              >
                {{ translations.accept }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
export default {
  props: {
    value: Boolean,
  },
  data: () => ({
    samplingType: [],
    analysisTypes: [],
    vegetalSampleTypes: [],
    packagesSolena: [],
    distributor: localStorage.getItem("distributionOrganizationId"),
    organizationId: null,
    currentPackageName: null,
    sample: null,
    loading: false,
    // form
    sampleType: null,
    analysisType: null,
    vegetalType: null,
    packagesSolenaSelected: null,
  }),
  async created() {
    this.samplingType = [
      {
        text: this.translations.samplingType["CLASSIC"],
        value: "CLASSIC",
      },
      {
        text: this.translations.samplingType["MAS_VEGETABLE"],
        value: "MAS_VEGETABLE",
      },
    ];
    this.analysisTypes = [
      { text: this.translations.analysisTypes["INITIAL"], value: "INITIAL" },
      {
        text: this.translations.analysisTypes["MONITORING"],
        value: "MONITORING",
      },
    ];
    this.vegetalSampleTypes = [
      {
        text: this.translations.vegetalSampleTypes["Seedling"],
        value: "Seedling",
      },
      { text: this.translations.vegetalSampleTypes["Root"], value: "Root" },
      { text: this.translations.vegetalSampleTypes["Seed"], value: "Seed" },
      { text: this.translations.vegetalSampleTypes["Stem"], value: "Stem" },
      { text: this.translations.vegetalSampleTypes["Leaf"], value: "Leaf" },
      {
        text: this.translations.vegetalSampleTypes["Fruit"],
        value: "Fruit",
      },
      {
        text: this.translations.vegetalSampleTypes["Flower"],
        value: "Flower",
      },
    ];
    await this.getPackges();
    await this.getCurrentPackage();
    let response = await this.getSampleById(this.$route.params.sampleId);
    this.sample = response.sample;

    this.sampleType = this.samplingType.find(
      (element) => element.value == this.sample.sampleType
    );
    if (
      this.sample.status != "NOT_STARTED" &&
      this.sample.status != "IN_PROGRESS"
    ) {
      this.analysisType = this.analysisTypes.find(
        (element) => element.value == this.sample.tracingStatus
      );
    }
    if (this.sampleType && this.sampleType.value == "MAS_VEGETABLE") {
      this.vegetalType = this.vegetalSampleTypes.find(
        (element) => element.value == this.sample.vegetableType
      );
    }
  },
  computed: {
    ...mapState("samples", ["area_selected"]),
    ...mapState("session", ["permissions"]),
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("packageSolena", [
      "getPackagesByDistributor",
      "getPackagesByClient",
      "getPackagesInSample",
    ]),
    ...mapActions("samples", [
      "getSampleById",
      "setSamplePackage",
      "updateSampleInfo",
    ]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    closeModal() {
      this.show = false;
    },
    async getPackges() {
      try {
        let user = JSON.parse(localStorage.getItem("user"));
        if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
          this.organizationId = localStorage.getItem("organizationId");
        } else {
          this.organizationId = localStorage.getItem("clientId");
        }

        let response = null;

        if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
          response = await this.getPackagesByClient({
            commercialOrganizationId: this.organizationId,
          });
        } else {
          response = await this.getPackagesByDistributor({
            distributorId: this.distributor,
          });
        }
        this.packagesSolena = response;

        if (
          this.permissions.find(
            (permission) => permission == "not_package_in_sampling"
          ) &&
          this.packagesSolena.length != 0
        ) {
          this.packagesSolena.unshift({
            name: this.translations.label_not_applicable,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getCurrentPackage() {
      try {
        let response = await this.getPackagesInSample({
          sampleId: this.$route.params.sampleId,
        });
        this.currentPackageName = response.packageSolena.name;
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          let samplePayload = {
            tracingstatus: this.analysisType.value,
            sampleType: this.sampleType.value,
            vegetableType: this.vegetalType ? this.vegetalType.value : null,
            sampleId: this.$route.params.sampleId,
          };
          let packagePayload = {
            sampleId: this.$route.params.sampleId,
            pckageId: this.packagesSolenaSelected
              ? this.packagesSolenaSelected._id
              : null,
          };
          await this.updateSampleInfo(samplePayload);
          await this.setSamplePackage(packagePayload);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: this.translations.updated_information,
            timeout: 4000,
          });
          this.show = false;
        } catch (error) {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        } finally {
          this.loading = false;
        }
      }
    },
    formatItemText(item) {
      return `${item.name} - ${item.laboratoryName}`;
    },
  },
};
</script>

<style scoped></style>
